import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  FinancialPeriodParams,
  FinancialSummaryResponse
} from "../financialReport.types";
import { requestFinancialSummary } from "./financialSummary.request";

const useFinancialSummary = (
  params: FinancialPeriodParams,
  options?: QueryOptions<FinancialSummaryResponse, ApiServiceError<ApiError>>
) => {
  return useQuery({
    queryKey: ["financial-summary", params],
    queryFn: async () => await requestFinancialSummary(params),
    onError: toastServerError,
    ...options
  });
};

export default useFinancialSummary;
